import { render, staticRenderFns } from "./languages-list.vue?vue&type=template&id=52dd2d7a&scoped=true&"
import script from "./languages-list.vue?vue&type=script&lang=js&"
export * from "./languages-list.vue?vue&type=script&lang=js&"
import style0 from "./languages-list.styl?vue&type=style&index=0&id=52dd2d7a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd2d7a",
  null
  
)

export default component.exports